import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyeOff = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.25016 3.53337C8.82377 3.39911 9.41105 3.33199 10.0002 3.33337C15.8335 3.33337 19.1668 10 19.1668 10C18.661 10.9464 18.0577 11.8373 17.3668 12.6584M11.7668 11.7667C11.538 12.0123 11.262 12.2093 10.9553 12.346C10.6486 12.4826 10.3176 12.5561 9.9819 12.562C9.64623 12.5679 9.3128 12.5062 9.0015 12.3804C8.69021 12.2547 8.40743 12.0676 8.17004 11.8302C7.93264 11.5928 7.74549 11.31 7.61975 10.9987C7.49402 10.6874 7.43227 10.354 7.43819 10.0183C7.44411 9.68262 7.51759 9.35158 7.65423 9.04491C7.79087 8.73825 7.98787 8.46225 8.2335 8.23337M0.833496 0.833374L19.1668 19.1667M14.9502 14.95C13.5257 16.0359 11.7911 16.6374 10.0002 16.6667C4.16683 16.6667 0.833496 10 0.833496 10C1.87007 8.06829 3.30778 6.38055 5.05016 5.05004L14.9502 14.95Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgEyeOff;
